import { BaseModel } from "sjs-base-model";
import OrderItemModel from "../../orderItem/OrderItemModel";

// Returned Api Data sample
// const example = {
//     created: '2021-12-31T17:32:28Z',
//     orderId: 5,
//     state: "Completed",
//     isArchived: true,
//     paymentMethod: "Quota",
//     company: "Doe Ltd.",
//     sapBPId: 123456,
//     sapCompanyName = "Doe Ltd.",
//     firstName: "John",
//     lastName: "Doe",
//     email: "john@doe.com",
//     productCategoryName: "Market data stream files",
//     productName: "Eurex EOBI Enhanced Orderbook Interface File",
//     from: 20220101,
//     to: 20220131,
//     price: 1875,
//     remark: "Important remark",
//     byAdmin: false
// };

export default class OneOffsStatDataItemModel extends BaseModel {
    created = 0;
    orderId = 0;
    state = "";
    isArchived = false;
    paymentMethod = "";
    company = "";
    bpId = 0;
    bpName = "";
    firstName = "";
    lastName = "";
    email = "";
    price = 0;
    orderItems = [OrderItemModel];
    byAdmin = null;

    constructor(data) {
        super();
        this.update(data);
    }

    update(data) {
        super.update(data);
        this.byAdmin = this.byAdmin === null ? "N/A" : this.byAdmin ? "Yes" : "No";
    }
}
